import { useEffect, useState } from "react";

const labels = {
  ready: "Event stream online",
  disabled: "Event stream disabled",
  unavailable: "Event stream unavailable",
  loading: "Checking event stream",
};

export function EventBusStatus({ variant = "admin" }) {
  const [status, setStatus] = useState({
    driver: "kafka",
    state: "loading",
    enabled: false,
  });

  useEffect(() => {
    const controller = new AbortController();
    fetch("/api/v1/event-bus/status", {
      credentials: "same-origin",
      headers: { Accept: "application/json" },
      signal: controller.signal,
    })
      .then(async (response) => {
        const payload = await response.json().catch(() => null);
        if (!response.ok || !payload?.data) {
          throw new Error("Event stream status is unavailable.");
        }
        setStatus(payload.data);
      })
      .catch((error) => {
        if (error.name !== "AbortError") {
          setStatus({
            driver: "kafka",
            state: "unavailable",
            enabled: true,
          });
        }
      });

    return () => controller.abort();
  }, []);

  return (
    <output
      className={`sq-event-bus-status sq-event-bus-status--${variant} is-${status.state}`}
      data-event-bus-driver={status.driver}
      data-event-bus-state={status.state}
      title={`Kafka topic: ${status.topic || "squra.domain-events.v1"}`}
      aria-live="polite"
    >
      <span aria-hidden="true" />
      {labels[status.state] || labels.unavailable}
    </output>
  );
}
